import React, { PropsWithChildren } from 'react';
import { ContentListItem } from '../../../../_lib/components/ContentList';
import { Assignment, PageToPageAssignmentCard } from '../PageToPageAssignmentCard';

type PageToPageListItemProps = {
  assignment: Assignment;
};

export function PageToPageListItem({ children, assignment }: PropsWithChildren<PageToPageListItemProps>) {
  return (
    <ContentListItem>
      <div className="page-to-page-block__list-item">
        <PageToPageAssignmentCard {...assignment}>{children}</PageToPageAssignmentCard>
      </div>
    </ContentListItem>
  );
}
